import { Box, Grid, Paper, Typography, Chip } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';

const AiDialogSection = ({ feature, index, reverse }) => {
    const imageFirst = !reverse;

    const imageBlock = (
        <Box
            sx={{
                width: '100%',
                borderRadius: '12px',
                overflow: 'hidden',
                border: '1px solid #E9EBED',
                background: 'linear-gradient(145deg, #F5FCFC 0%, #E8EDF2 100%)',
                p: { xs: 2, md: 3 },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: { xs: 220, md: 280 },
            }}
        >
            <Box
                component="img"
                src={feature.image}
                alt={feature.imageAlt}
                loading="lazy"
                sx={{
                    width: '100%',
                    maxWidth: 420,
                    height: feature.imageFit === 'cover' ? { xs: 220, md: 280 } : 'auto',
                    maxHeight: 280,
                    objectFit: feature.imageFit || 'cover',
                    borderRadius: '8px',
                }}
            />
        </Box>
    );

    const contentBlock = (
        <Box>
            <Chip
                label={feature.tag}
                size="small"
                sx={{
                    mb: 1.5,
                    fontWeight: 600,
                    backgroundColor: '#E8EDF2',
                    color: '#4A6984',
                    border: '1px solid rgba(74, 105, 132, 0.25)',
                }}
            />
            <Typography
                component="h3"
                variant="h5"
                sx={{ fontWeight: 700, color: '#03363D', mb: 0.5, lineHeight: 1.3 }}
            >
                <Box
                    component="span"
                    sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 32,
                        height: 32,
                        borderRadius: '50%',
                        backgroundColor: '#03363D',
                        color: '#fff',
                        fontSize: '0.95rem',
                        mr: 1.5,
                        verticalAlign: 'middle',
                    }}
                >
                    {index + 1}
                </Box>
                {feature.title}
            </Typography>
            <Typography
                variant="body2"
                sx={{ color: 'text.secondary', mb: 2.5, fontStyle: 'italic', pl: { md: 5.5 } }}
            >
                {feature.titleEn}
            </Typography>

            <Paper
                elevation={0}
                sx={{
                    p: 2,
                    mb: 2.5,
                    backgroundColor: '#F8F9F9',
                    borderLeft: '4px solid #4A6984',
                    borderRadius: '4px',
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 600,
                        color: '#17494D',
                        fontSize: '0.875rem',
                        mb: 0.75,
                        textTransform: 'uppercase',
                        letterSpacing: '0.04em',
                    }}
                >
                    功能說明
                </Typography>
                <Typography sx={{ lineHeight: 1.8, color: 'text.primary' }}>{feature.overview}</Typography>
            </Paper>

            <Typography
                sx={{
                    fontWeight: 600,
                    color: '#17494D',
                    mb: 1.5,
                    fontSize: '0.875rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.04em',
                }}
            >
                實際應用場景範例
            </Typography>
            <Grid container spacing={1.5}>
                {feature.scenarios.map((scene) => (
                    <Grid item xs={12} key={scene.label}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                border: '1px solid #E9EBED',
                                borderRadius: '8px',
                                backgroundColor: '#FFFFFF',
                            }}
                        >
                            <Typography sx={{ fontWeight: 700, color: '#03363D', mb: 1.5 }}>
                                {scene.label}
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 1, mb: 1.5 }}>
                                <PersonOutlineIcon sx={{ color: '#68737D', fontSize: 20, mt: 0.3 }} />
                                <Box>
                                    <Typography
                                        variant="caption"
                                        sx={{ color: 'text.secondary', fontWeight: 600 }}
                                    >
                                        使用者輸入
                                    </Typography>
                                    <Typography variant="body2" sx={{ lineHeight: 1.7 }}>
                                        「{scene.userInput}」
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <SmartToyOutlinedIcon sx={{ color: '#4A6984', fontSize: 20, mt: 0.3 }} />
                                <Box>
                                    <Typography
                                        variant="caption"
                                        sx={{ color: '#4A6984', fontWeight: 600 }}
                                    >
                                        AI 即時回覆
                                    </Typography>
                                    <Typography variant="body2" sx={{ lineHeight: 1.7, color: 'text.primary' }}>
                                        {scene.aiReply}
                                    </Typography>
                                </Box>
                            </Box>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );

    return (
        <Box component="section" id={feature.id} sx={{ mb: { xs: 5, md: 7 }, scrollMarginTop: '80px' }}>
            <Grid container spacing={{ xs: 3, md: 5 }} alignItems="flex-start">
                {imageFirst ? (
                    <>
                        <Grid item xs={12} md={5}>
                            {imageBlock}
                        </Grid>
                        <Grid item xs={12} md={7}>
                            {contentBlock}
                        </Grid>
                    </>
                ) : (
                    <>
                        <Grid item xs={12} md={7} sx={{ order: { xs: 2, md: 1 } }}>
                            {contentBlock}
                        </Grid>
                        <Grid item xs={12} md={5} sx={{ order: { xs: 1, md: 2 } }}>
                            {imageBlock}
                        </Grid>
                    </>
                )}
            </Grid>
        </Box>
    );
};

export default AiDialogSection;
